import styled from 'styled-components';

export const MapContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  height: 100%;
`;
